"use client";

import React from "react";

export function Gallery10_1() {
  return (
    /* bg-wood-light = světle šedá, font-sans = Inter */
    <section className="bg-wood-light text-black font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        
        {/* Nadpis sekce - Gelasio */}
        <div className="mb-12 text-center md:mb-18 lg:mb-20">
          <h2 className="text-[32px] font-bold font-serif leading-[1.2] md:text-[48px] lg:text-[56px]">
            
          </h2>
        </div>

        {/* Masonry layout - přesně 7 fotek (2 vlevo, 3 uprostřed, 2 vpravo) */}
        <div className="gap-4 space-y-4 md:columns-2 lg:columns-3 md:gap-6 md:space-y-6">
          
          {/* 1. fotka */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 14png.png" className="w-full object-cover" alt="Realizace 1" />
          </div>

          {/* 2. fotka */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 24.png" className="w-full object-cover" alt="Realizace 2" />
          </div>

          {/* 3. fotka */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 34.png" className="w-full object-cover" alt="Realizace 3" />
          </div>

          {/* 4. fotka */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 44.png" className="w-full object-cover" alt="Realizace 4" />
          </div>

          {/* 5. fotka */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 54.png" className="w-full object-cover" alt="Realizace 5" />
          </div>

          {/* 6. fotka */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 64.png" className="w-full object-cover" alt="Realizace 6" />
          </div>

          {/* 7. fotka */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 74png.png" className="w-full object-cover" alt="Realizace 7" />
          </div>

        </div>
      </div>
    </section>
  );
}